import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { authService } from '../../services/authService';
import { API_BASE_URL } from '../../config/api';
import { PERMISSION_OPTIONS } from './permissionOptions';

import {
  Drawer,
  Form,
  Input,
  Button,
  Space,
  Checkbox,
  Divider,
} from 'antd';

// Parent remounts this drawer per user via key={user.keycloakID}, so state
// can be seeded from props once in the constructor.
export default class EditUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { ...props.user.permissions },
      isClientAdmin: props.user.isClientAdmin === 1,
      newPassword: '',
      saving: false,
      errors: [],
    };
  }

  togglePermission = (key, checked) => {
    this.setState({
      permissions: {
        ...this.state.permissions,
        [key]: checked ? 1 : 0,
      },
    });
  };

  submit = async () => {
    const token = await authService.ensureValidToken();
    if (!token) {
      console.error('Not authenticated');
      return;
    }

    this.setState({ saving: true, errors: [] });

    const data = {
      permissions: this.state.permissions,
      isClientAdmin: this.state.isClientAdmin ? 1 : 0,
    };
    if (this.state.newPassword) {
      data.password = this.state.newPassword;
    }

    axios({
      method: 'PUT',
      url: `${API_BASE_URL}/connect/users/${this.props.user.keycloakID}`,
      headers: { Authorization: `Bearer ${token}` },
      data: data,
    }).then(res => {
      toast.success(`User ${this.props.user.username} was updated`);
      this.setState({ saving: false }, () => {
        this.props.loadData();
        this.props.onClose();
      });
    }).catch(err => {
      console.log(err);
      this.setState({
        saving: false,
        errors: [err.response?.data?.error || 'Failed to update user'],
      });
    });
  };

  render() {
    const { visible, onClose, user, isSelf } = this.props;
    return (
      <Drawer
        title={`Edit User: ${user.username}`}
        onClose={onClose}
        open={visible}
        extra={
          <Space>
            <Button onClick={onClose}>
              Cancel
            </Button>
            <Button type="primary" onClick={this.submit} loading={this.state.saving}>
              Save
            </Button>
          </Space>
        }
      >
        <Form layout="vertical">
          <Divider orientation="left" plain>Page Access</Divider>

          {PERMISSION_OPTIONS.map(option => (
            <div key={option.key} style={{ marginBottom: 8 }}>
              <Checkbox
                checked={this.state.permissions[option.key] === 1}
                onChange={(e) => this.togglePermission(option.key, e.target.checked)}
              >
                {option.label}
              </Checkbox>
            </div>
          ))}

          <Divider orientation="left" plain>Administration</Divider>

          <Checkbox
            checked={this.state.isClientAdmin}
            disabled={isSelf}
            onChange={(e) => this.setState({ isClientAdmin: e.target.checked })}
          >
            Client Administrator (can manage users)
          </Checkbox>

          <Divider orientation="left" plain>Reset Password</Divider>

          <Form.Item label="New Password (leave blank to keep current)">
            <Input.Password
              value={this.state.newPassword}
              onChange={(e) => this.setState({ newPassword: e.target.value })}
            />
          </Form.Item>
        </Form>
        {this.state.errors.length ?
          <ul>
            {this.state.errors.map((item, index) => <li key={index} style={{ color: 'red' }}>{item}</li>)}
          </ul> : null
        }
      </Drawer>
    );
  }
}
